import { render, staticRenderFns } from "./bottomnav.vue?vue&type=template&id=755806b4&scoped=true&"
import script from "./bottomnav.vue?vue&type=script&lang=js&"
export * from "./bottomnav.vue?vue&type=script&lang=js&"
import style0 from "./bottomnav.vue?vue&type=style&index=0&id=755806b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755806b4",
  null
  
)

export default component.exports